import React, { useEffect, useState } from 'react';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import { EyeIcon, ProfileImage } from 'assets';
import { toastMessage } from 'shared/components/toast/Toast';
import TaskView from 'shared/modal/task_view/TaskView';
import CountDown from './CountDown';
import TaskColumn from './task_column/task_column';
import { AssignORTaskMutation, GetAllTaskQuery } from 'shared/services/task_service/TaskService';
import { task_assign, taskEnum } from 'shared/utils/Enum';
import DeleteConfirmation from 'shared/modal/delete_confirmation/DeleteConfirmation';
import { useSelector } from 'react-redux';
import InprogressColumn from './inprogress_column/inprogress_column';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import CompleteTask from './complete_column/complete_column';

export default function AllTask() {
    const { user } = useSelector((state) => state.root);

    const pendingQueryParams = new URLSearchParams({ status: taskEnum.PENDING }).toString();
    const inprogressQueryParams = new URLSearchParams({ status: taskEnum.INPROGESS, task_assigned: user.user._id }).toString();
    const completeQueryParams = new URLSearchParams({ status: taskEnum.COMPLETED, task_assigned: user.user._id }).toString();
    const { data: PendingData, isLoading } = GetAllTaskQuery(pendingQueryParams);
    const { data: InprogressData } = GetAllTaskQuery(inprogressQueryParams);
    const { data: CompleteData } = GetAllTaskQuery(completeQueryParams);
    const { mutate: assignTaskMutate, isLoading: assignTaskLoading, isSuccess: assignTaskIsSuccess } = AssignORTaskMutation();

    const [tasklist, setTasklist] = useState([]);
    const [openWidget, setOpenWidget] = useState(false);
    const [taskView, setTaskview] = useState('');
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [taskDetail, setTaskDetail] = useState(null);

    useEffect(() => {
        setTasklist(PendingData || []);
    }, [PendingData]);
    useEffect(() => {
        if (assignTaskIsSuccess) {
            closeConfirmationTask();
        }
    }, [assignTaskIsSuccess]);

    const closeWidget = () => setOpenWidget(false);

    const opentaskview = (task) => {
        setTaskview(task);
        setOpenWidget(true);
    };
    const assignMeFunction = (item) => {
        if ((InprogressData || []).length > 2) {
            toastMessage('error', 'Already Assigned 3 Task');
        } else {
            setTaskDetail(item);
            setOpenConfirmation(true);
        }
    };
    const closeConfirmationTask = () => {
        setTaskDetail(null);
        setOpenConfirmation(false);
    };

    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <div className={styles.Header}>
                    <Heading heading={'Task Information'} headingStyle={styles.Heading} />
                </div>
                <div className={styles.Header}>
                    <div className={styles.Mainflex}>
                        <TaskColumn tasklist={tasklist} opentaskview={opentaskview} handleAssign={assignMeFunction} heading="All Task" />
                        <div className={styles.Taskitem}>
                            <div className={styles.Header}>
                                <Heading heading={'Inprogress Task'} headingStyle={styles.Heading} />
                            </div>
                            <div className={styles.Listing}>
                                {InprogressData?.map((pending, pendingInx) => (
                                    <InprogressColumn key={pendingInx} Index={pendingInx + 1} inprogress={pending} />
                                ))}
                            </div>
                        </div>
                        <CompleteTask tasklist={CompleteData || []} heading="Completed Task" />
                    </div>
                </div>
            </div>
            <TaskView show={openWidget} handleClose={closeWidget} tasks={taskView} />
            <DeleteConfirmation
                show={openConfirmation}
                loading={assignTaskLoading}
                ConfimationHeading="Task Assign"
                Desc={'Are you sure you want to get this task?'}
                DeleteHandler={() => {
                    let task_body = {
                        task_id: taskDetail?._id,
                        assign_by: user?.user?._id,
                        task_action: task_assign.ASSIGN
                    };
                    assignTaskMutate(task_body);
                }}
                ActionText={'Assign Me'}
                handleClose={closeConfirmationTask}
            />
            {isLoading && <OverlayLoading />}
        </DashboardWrapper>
    );
}
